import { sumValues, throwTranslatableError } from '@/core';
import { updateTripOrdersRequest } from '../../requests';
import deepCopy from 'deepcopy';
import createTripOrder from './addOrdersToTrip/createTripOrder';
import createSubOrderUpdate from './addOrdersToTrip/createSubOrderUpdate';
import rdbClient from 'rdb-client';

export default async function addOrdersToTrip({ state, commit, dispatch }, { orders, tripId, despatchOption, deliveryOption, etd, eta, customDespatchParty, customDeliveryParty }) {
	if (!orders || !tripId) {
		throw new Error('failedToAddOrderToTrip');
	}
	let trip = state.tripSearch.trips.find(({ id }) => id === tripId);
	if (!trip) {
		throw new Error('failedToAddOrderToTrip');
	}

	// Remove orders already on trip
	let newOrders = orders.filter(order => {
		if (!trip.orders) return true;
		return trip.orders.every( x => order.orderId !== x.orderId );
	});
	if (orders.length !== newOrders.length) {
		throw new Error ('orderAlreadyAdded');
	}

	let newOrdersInRange = newOrders;
	// Remove orders with etd outside trip date range
	//let newOrdersInRange = newOrders.filter(order => order.etd.date <= etd && order.etd.date <= eta);

	if (newOrdersInRange.length > 0) {
		let subOrderUpdates = [];

		let loadingSeqNo = 0;

		if (trip.orders.length) {
			let maxLoadingSeqNo = trip.orders
				.reduce((acc, curr) => {

					if (curr.loadingSeqNo === undefined || curr.loadingSeqNo === null)
						return acc;

					if (acc > curr.loadingSeqNo)
						return acc;
					else
						return curr.loadingSeqNo;
				}, 0);

			loadingSeqNo = maxLoadingSeqNo + 1;
		}

		let addedOrders = newOrdersInRange.map(order => {
			let newOrder = createTripOrder(order, trip, etd, eta, despatchOption, deliveryOption, customDespatchParty, customDeliveryParty, loadingSeqNo);
			subOrderUpdates.push(createSubOrderUpdate(newOrder));
			return newOrder;
		});

		let tripClone = deepCopy(trip);

		// Add orders
		let ordersList = trip.orders ? trip.orders.concat(addedOrders) : addedOrders;
		if (ordersList) {
			trip.volume = sumValues(ordersList, 'volume');
			trip.grossWeight = sumValues(ordersList, 'grossWeight');
			trip.loadingMeters = sumValues(ordersList, 'loadingMeters');
		}

		try {
			let patch = rdbClient.createPatch(tripClone, trip);
			let response = await updateTripOrdersRequest(trip.id, { tripPatches: patch, subOrderUpdates });
			commit('setTrip', response);
			dispatch('orderSearch/refreshOrders', newOrdersInRange.map(x => x.orderId));
			commit('setSelectedGridOrderIds', []);
			commit('setFilteredGridOrderIds', []);
		} catch (e) {
			throwTranslatableError(e, 'failedToAddOrderToTrip');
		}
	}
}